/**
 * @file 大逃杀首页store
 */
import Vue from 'vue';
import Vuex from 'vuex';
import server from '@/pages/pano-game/service';
import Const from '@/pages/pano-game/constant/Constant';

Vue.use(Vuex);

const historyMn = localStorage.getItem('escape-match-mn');

const state = {
    escapeData: {},
    // 匹配人数
    matchMaxNum: historyMn || 0,
    escapeContinue: 2,
    userInfoList: [],
    honorInfoList: []
};

const mutations = {
    // 初始化大逃杀首页数据
    setEscapeData(state, data) {
        state.escapeData = Object.assign(state.escapeData, data || {});
        state.userInfoList = state.escapeData.todayData.map(v => {
            return {
                topText: v.number + Const.escapeHonorTypeSymbols[v.type] || '',
                bottomText: v.title,
                textColor: 'blue'
            };
        });
        state.honorInfoList = state.escapeData.historyData.map(v => {
            return {
                topText: v.type === 'time' ? v.number : v.number + Const.escapeHonorTypeSymbols[v.type] || '',
                bottomText: v.title,
                textColor: v.type === 'time' ? 'yellow' : 'blue'
            };
        });
    },
    // 初始化最大匹配数量
    setMatchMaxNum(state, data = -1) {
        const historyMn = localStorage.getItem('escape-match-mn');
        state.matchMaxNum = data === -1 ? historyMn : data || 0;
        localStorage.setItem('escape-match-mn', state.matchMaxNum);
    }
};
const getters = {};
const actions = {
    getEscapeMain: ({commit, rootState}) => {
        const playingNum = localStorage.getItem('escape-playing-num');
        const reqParams = {
            olnum: rootState.playingNum || playingNum,
            type: Const.gameMode.escape
        };
        return server('getEscapeMain', reqParams).then(res => {
            if (res && res.errno === 0 && res.data) {
                commit('setEscapeData', res.data);
                commit('setMatchMaxNum', res.data.matchMaxNum);
                return res;
            }
            throw new Error(res.errstr || 'getwrongquestion 数据结构异常');
        });
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};